// wishlist
var wishlistInit = false;
class Wishlist extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute("data-product_id");
    this.customerId = this.getAttribute("data-customer_id");
    this.dataAdded = this.getAttribute("data-added");
    this.menuIcon = document.querySelector("#wishIconHeader svg");
    this.addedSvg = `<svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 14.2256L7.32649 13.6171C5.87578 12.2917 4.67578 11.1573 3.72649 10.2137C2.7772 9.27009 2.02791 8.43789 1.47862 7.71709C0.929333 6.99629 0.545578 6.34416 0.327356 5.76069C0.109119 5.17721 0 4.59031 0 4C0 2.86951 0.384044 1.92022 1.15213 1.15213C1.92022 0.384045 2.86951 0 4 0C4.78176 0 5.5151 0.2 6.2 0.6C6.8849 1 7.4849 1.58176 8 2.34529C8.5151 1.58176 9.1151 1 9.8 0.6C10.4849 0.2 11.2182 0 12 0C13.1305 0 14.0798 0.384045 14.8479 1.15213C15.616 1.92022 16 2.86951 16 4C16 4.59031 15.8909 5.17721 15.6726 5.76069C15.4544 6.34416 15.0707 6.99629 14.5214 7.71709C13.9721 8.43789 13.2257 9.27009 12.2821 10.2137C11.3385 11.1573 10.1356 12.2917 8.67351 13.6171L8 14.2256Z" fill="black"/>
    </svg>
    `;
    this.blankSvg = `<svg width="16" height="15" viewBox="0 0 16 15" fill="red" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 14.2256L7.32649 13.6171C5.87578 12.2917 4.67578 11.1573 3.72649 10.2137C2.7772 9.27009 2.02791 8.43789 1.47862 7.71709C0.929333 6.99629 0.545578 6.34416 0.327356 5.76069C0.109119 5.17721 0 4.59031 0 4C0 2.86951 0.384044 1.92022 1.15213 1.15213C1.92022 0.384045 2.86951 0 4 0C4.78176 0 5.5151 0.2 6.2 0.6C6.8849 1 7.4849 1.58176 8 2.34529C8.5151 1.58176 9.1151 1 9.8 0.6C10.4849 0.2 11.2182 0 12 0C13.1305 0 14.0798 0.384045 14.8479 1.15213C15.616 1.92022 16 2.86951 16 4C16 4.59031 15.8909 5.17721 15.6726 5.76069C15.4544 6.34416 15.0707 6.99629 14.5214 7.71709C13.9721 8.43789 13.2257 9.27009 12.2821 10.2137C11.3385 11.1573 10.1356 12.2917 8.67351 13.6171L8 14.2256ZM8 13.0222C9.42222 11.7368 10.5926 10.6356 11.5111 9.7188C12.4296 8.802 13.1556 8.00656 13.6889 7.33249C14.2222 6.65841 14.5926 6.06126 14.8 5.54102C15.0074 5.0208 15.1111 4.50713 15.1111 4C15.1111 3.11111 14.8148 2.37037 14.2222 1.77778C13.6296 1.18519 12.8889 0.888889 12 0.888889C11.2923 0.888889 10.6393 1.09088 10.041 1.49487C9.44274 1.89885 8.90713 2.50712 8.4342 3.31967H7.5658C7.08147 2.49573 6.54302 1.88462 5.95042 1.48633C5.35783 1.08804 4.70769 0.888889 4 0.888889C3.1225 0.888889 2.38461 1.18519 1.78633 1.77778C1.18804 2.37037 0.888889 3.11111 0.888889 4C0.888889 4.50713 0.992593 5.0208 1.2 5.54102C1.40741 6.06126 1.77778 6.65841 2.31111 7.33249C2.84444 8.00656 3.57037 8.79916 4.48889 9.71027C5.40741 10.6214 6.57778 11.7254 8 13.0222Z" fill="black"></path>
    </svg>`;
    this.loadingSvg = document.querySelector(".wishlist-loading");

    this.isListPage = this.getAttribute("list-page") ? true : false;
    this.isLoggedUser = true
    this.addEventListener('click', () => {
      this.clickHandler();
    });

    if(this.customerId == "null"){
      this.initLocalStorage();
      this.isLoggedUser = false;
    }
    if(!wishlistInit){
      wishlistInit = true;
      if(this.isLoggedUser){
        this.syncCustomerData();
      }
    }
    if(this.isListPage){
      return;
    }
    this.getProductStatus().then(() => {
      this.style.display = "block";
    });
  }

  syncCustomerData(){
    const url = "/apps/app/list?customerId=" + this.customerId + "&shop=" + window.location.hostname;
    return fetch(url).then(response => response.json()).then(json => {
      if(json.addedWishlist){
        localStorage.setItem("wgt.wishlist", json.addedWishlist.value);
      }
    });
  }

  initLocalStorage(){
    if(!localStorage.getItem("wgt.wishlist")){
      localStorage.setItem("wgt.wishlist", "");
    }
    var storeData = null;
    if(!localStorage.getItem("wgt.data")){
      return fetch('/collections/all?view=product-info').then(response => response.json()).then(json => {
          storeData = json;
          localStorage.setItem("wgt.data", JSON.stringify(storeData));
      }).then(async () => {
          await fetch('/collections/all?view=product-info&page=2').then(response => response.json()).then(json => {
              storeData = storeData.concat(json);
              localStorage.setItem("wgt.data", JSON.stringify(storeData));
          });
      })
    }
  }

  loadingSvgAction(action="none"){
    if(this.loadingSvg){
      this.loadingSvg.style.display = action;
    }
  }

  menuIconAnimation(){
    this.menuIcon.style.fill = "black";
    setTimeout(() => {
      this.menuIcon.style.fill = "none";
    }, 3000);
  }

  getLocalStorage(){
    return localStorage.getItem("wgt.wishlist");
  }

  setLocalStorage(action){
    let wishlistStorage = this.getLocalStorage();
    let newWishlistStorage = "";
    if(action == "add"){
      newWishlistStorage = wishlistStorage + this.productId + ",";
    }else{
      let removeProduct = this.productId + ",";
      newWishlistStorage = wishlistStorage.replace(removeProduct, "");
    }
    localStorage.setItem("wgt.wishlist", newWishlistStorage);
  }

  getProductStatus(){
      let wishlistStorage = this.getLocalStorage();
      if(wishlistStorage.includes(this.productId)){
        this.updateDataAdded();
        this.changeSvg();
      }
      return new Promise(resolve => { resolve(); });
  }

  updateDataAdded(){
    this.dataAdded = (this.dataAdded == "true") ? "false" : "true";
    this.setAttribute("data-added", this.dataAdded);
  }

  changeSvg(){
    this.innerHTML = (this.dataAdded == "true") ? this.addedSvg : this.blankSvg;
  }

  removeElement(){
    let removeCardEl = this.closest(".wishlist-column");
    removeCardEl.remove();
    let wishlistRowEl = document.querySelector(".wishlist-row");
    if(wishlistRowEl && wishlistRowEl.childElementCount == 1){
      document.querySelector(".wishlist-empty").style.display = "block";
      wishlistRowEl.style.display = "none";
    }
  }

  clickHandler(){
    this.loadingSvgAction("block");
    if(this.isListPage){
      this.productId = this.getAttribute("data-product_id");
      this.removeElement();
    }
    if(!this.isLoggedUser){
      if(this.dataAdded == "false"){
        this.setLocalStorage("add");
      }else{
        this.setLocalStorage("remove");
      }
      this.updateDataAdded();
      this.changeSvg();
      this.loadingSvgAction("none");
      this.menuIconAnimation();
      return;
    }
    const url = "/apps/app/handle?shop=" + window.location.hostname;
    return fetch(url, {
        body: JSON.stringify({
          customerId: this.customerId,
          productId: this.productId
        }),
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
        },
        method: 'POST'
    }).then(response => response.json()).then(json => {
      if(json.res){
        localStorage.setItem("wgt.wishlist", json.res.value);
      }
      this.updateDataAdded();
      this.changeSvg();
      this.loadingSvgAction("none");
      this.menuIconAnimation();
    });
  }
}

customElements.define('wishlist-app', Wishlist);
// endwishlist